export const REQUEST_TYPE = [
  { value: '100', label: 'Менторская программа'},
  { value: '200', label: 'Сервис индивидуальных консультаций для участников Кластера ИТ'},
];
